import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditListComponentComponent } from '../../../collections/components/edit-list-component/edit-list-component.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ManipulationsToolbarComponent } from "../../../../shared/components/manipulations-toolbar/manipulations-toolbar.component";
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ListCollectionsItemComponent } from "../list-collections-item/list-collections-item.component";
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { CollectionListsStore } from '../../store/lists-store';
import { SavedListsHeaderComponent } from '../saved-lists-header/saved-lists-header.component';
import { Observable, map, switchMap } from 'rxjs';
import { NoResultComponent } from 'src/app/shared/components/no-result/no-result.component';
import { OptionsList } from 'src/app/models/optionsList.model';

@Component({
    selector: 'que-lists-collections',
    templateUrl: './lists-collections.component.html',
    styleUrls: ['./lists-collections.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, SavedListsHeaderComponent, NoResultComponent, EditListComponentComponent, ReactiveFormsModule, ManipulationsToolbarComponent, TranslateDirective, TranslatePipe, ListCollectionsItemComponent]
})
export class ListsCollectionsComponent {
  #listsStore = inject(CollectionListsStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  collectionLists$ = toSignal(this.#listsStore.collectionLists$.pipe(map(x => x.result)));
  isDisplayNotActiveItems$ = this.#manipulationsToolbarStore.isDisplayNotActiveItems$;
  listsExtra$ = toSignal(this.#listsStore.savedListsExtra$);
  // #dialog = inject(MatDialog);
  isResult$ = toSignal(this.#listsStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isEmpty$ = toSignal(this.#listsStore.isEmpty$);
  loadingExtra$ = toSignal(this.#listsStore.loadingExtra$);
  loading$ = toSignal(this.#listsStore.loading$);
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  constructor(private el: ElementRef) {
    // this.collectionLists$ = toSignal(this.isDisplayNotActiveItems$.pipe(
    //   switchMap(isNotActive => {
    //     return this.filterListCollections(!isNotActive);
    //   })
    // ));
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.listsExtra$()!.result.length == 10;
        if (this.listsExtra$() && this.listsExtra$()!.result.length > 0) {
          this.getQuestionnaireExtra();
        }
        if (this.listsExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }

  private filterListCollections(isActive: boolean): Observable<OptionsList[]> {
    const lists$ = this.#listsStore.collectionLists$;
    return lists$.pipe(
      map(x => x.result),
      map(lists => {
        if (isActive !== undefined) {
          return lists.filter(x => x.isActive == isActive)
        } else {
          return lists;
        }
      })
    );
  }

  getQuestionnaireExtra() {
    this.#listsStore.updateSavedListWithExtra();
  }

  loadMore() {
    this.#listsStore.loadSavedListForExtra();
  }

}
